import {FieldTime, FormSection} from "../../../ui";
import {StatisticsConfigurationDto} from "../../../../api/cms";
import {parseStringToTime} from "../../../../utils";

interface CmsStatisticsConfigurationFormData {
    statisticsConfiguration: StatisticsConfigurationDto
}

export interface CmsStatisticsConfigurationFormHelp {
    slaEndOfWorkday?: string
}

interface CmsStatisticsConfigurationFormProps {
    value: CmsStatisticsConfigurationFormData
    onChange: (value: CmsStatisticsConfigurationFormData) => any
    validate: () => Promise<any>
    saving: boolean
    help: CmsStatisticsConfigurationFormHelp
}

const CmsStatisticsConfigurationForm = function CmsStatisticsConfigurationForm({
                                                                                 value,
                                                                                 saving,
                                                                                 onChange,
                                                                                 validate,
                                                                                 help
                                                                             }: CmsStatisticsConfigurationFormProps) {
    const slaEndOfWorkday = parseStringToTime(value.statisticsConfiguration?.slaEndOfWorkday)

    return <FormSection
        label={"Statistiken"}>
        <>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldTime
                        value={slaEndOfWorkday}
                        label={"Versand Uhrzeit SLA"}
                        required={true}
                        disabled={saving}
                        help={help.slaEndOfWorkday}
                        invalid={Boolean(help.slaEndOfWorkday)}
                        onBlur={async () => await validate()}
                        onChange={v => {
                            const slaEndOfWorkday = `${v.hours.toString().padStart(2, '0')}:${v.minutes.toString().padStart(2, '0')}:00`
                            onChange({
                                ...value,
                                statisticsConfiguration: {
                                    ...value.statisticsConfiguration,
                                    slaEndOfWorkday
                                }
                            })
                        }}
                    />
                </div>
            </div>
        </>
    </FormSection>
}

export {
    CmsStatisticsConfigurationForm
}
